'use client';

import Slider from 'react-slick';
import React, { useRef } from 'react';
import styles from './SliderContainer.module.scss';
import Button, { ButtonType } from '@/components/Button/Button';

const SliderContainer = ({ children }: { children: React.ReactNode }) => {
  let sliderRef = useRef<Slider | null>(null);
  const settings = {
    arrows: false,
    dots: true,
    infinite: true,
    variableWidth: true,
    className: styles.slider,
    dotsClass: styles.dots,
    initialSlide: 0,
    // eslint-disable-next-line react/no-unstable-nested-components
    customPaging: (i: number) => (
      <button
        key={i}
        type='button'
        className={styles.dot}
      >
        <span>{' '}</span>
      </button>
    ),
    responsive: [{
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    }],
  };

  const next = () => {
    sliderRef.current?.slickNext();
  };
  const previous = () => {
    sliderRef.current?.slickPrev();
  };

  return (
    <div>
      <Slider
        ref={(slider) => {
          sliderRef.current = slider;
        }}
        {...settings}
      >
        {children}
      </Slider>
      <div className={styles.buttons}>
        <Button
          type={ButtonType.SECONDARY_LIGHT}
          iconName='arrow_back'
          onClick={previous}
        />
        <Button
          type={ButtonType.SECONDARY_LIGHT}
          iconName='arrow_forward'
          onClick={next}
        />
      </div>
    </div>
  );
};

export default SliderContainer;
